const CreativeAgencyOneAddPlanner = () => {
  return (
    <>
      <div className="section-space bgc-background">
        <div className="section-space--sm-bottom">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10">
                <h4 className="heading-4 text-center clr-text mb-0">
                  Get Started For Free Add & Plan Later
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div className="container-xxl">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="list-group flex-row justify-content-center margin-bottom-10">
                <a
                  className="package-btn link d-inline-flex text-center font-weight-bold clr-text :clr-text bgc-white padding-y-3 padding-x-6 rounded-start active"
                  data-bs-toggle="list"
                  href="#monthly-package"
                >
                  Monthly
                </a>
                <a
                  className="package-btn link d-inline-flex text-center font-weight-bold clr-text :clr-text bgc-white padding-y-3 padding-x-6 rounded-end"
                  data-bs-toggle="list"
                  href="#yearly-package"
                >
                  Yearly
                </a>
              </div>
            </div>
            <div className="col-12">
              <div className="tab-content">
                <div className="tab-pane fade show active" id="monthly-package">
                  <div className="row g-4">
                    <div className="col-md-6">
                      <div className="package-card bgc-white rounded-4 padding-4 padding-xsm-6 padding-xl-8 d-flex flex-column flex-xl-row align-items-start gap-6">
                        <div className="padding-x-6 padding-y-8 bgc-secondary text-center rounded-pill flex-shrink-0">
                          <div className="d-flex align-items-start justify-content-center">
                            <h6 className="heading-6 mb-0 clr-white font-weight-bold">
                              $
                            </h6>
                            <h4 className="heading-4 mb-0 clr-white font-weight-bold">
                              54
                            </h4>
                          </div>
                          <p className="mb-0 clr-white font-weight-semibold">
                            /month
                          </p>
                        </div>
                        <div className="flex-grow-1">
                          <h5 className="heading-5 font-weight-bold clr-text margin-bottom-6">
                            Starter Plan
                          </h5>
                          <p className="clr-paragraph font-weight-bold margin-bottom-8">
                            Make your work easier with an integrated properly
                            together.
                          </p>
                          <div className="row g-4 margin-bottom-8">
                            <div className="col-lg-6">
                              <div className="d-flex gap-2 align-items-center clr-paragraph">
                                <div className="flex-shrink-0">
                                  <i className="far fa-check-circle"></i>
                                </div>
                                <p className="mb-0 flex-grow-1">
                                  Get real time answers
                                </p>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="d-flex gap-2 align-items-center clr-paragraph">
                                <div className="flex-shrink-0">
                                  <i className="far fa-check-circle"></i>
                                </div>
                                <p className="mb-0 flex-grow-1">
                                  Collaborate seamlessly
                                </p>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="d-flex gap-2 align-items-center clr-paragraph">
                                <div className="flex-shrink-0">
                                  <i className="far fa-check-circle"></i>
                                </div>
                                <p className="mb-0 flex-grow-1">
                                  Report on what matter
                                </p>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="d-flex gap-2 align-items-center clr-paragraph">
                                <div className="flex-shrink-0">
                                  <i className="far fa-check-circle"></i>
                                </div>
                                <p className="mb-0 flex-grow-1">
                                  Update Plans on the fly
                                </p>
                              </div>
                            </div>
                          </div>
                          <a
                            href="#"
                            className="link d-inline-flex text-center font-weight-semibold clr-text :clr-text border rounded-pill padding-y-5 padding-x-10 bgc-white lh-1"
                          >
                            Purchase Now
                          </a>
                        </div>
                        <div className="package-card__label">
                          <span className="d-block text-center font-weight-bold clr-white">
                            New
                          </span>
                          <span className="d-block text-center clr-white">
                            Offer
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="package-card bgc-white rounded-4 padding-4 padding-xsm-6 padding-xl-8 d-flex flex-column flex-xl-row align-items-start gap-6">
                        <div className="padding-x-6 padding-y-8 bgc-primary text-center rounded-pill flex-shrink-0">
                          <div className="d-flex align-items-start justify-content-center">
                            <h6 className="heading-6 mb-0 clr-white font-weight-bold">
                              $
                            </h6>
                            <h4 className="heading-4 mb-0 clr-white font-weight-bold">
                              54
                            </h4>
                          </div>
                          <p className="mb-0 clr-white font-weight-semibold">
                            /month
                          </p>
                        </div>
                        <div className="flex-grow-1">
                          <h5 className="heading-5 font-weight-bold clr-text margin-bottom-6">
                            Starter Plan
                          </h5>
                          <p className="clr-paragraph font-weight-bold margin-bottom-8">
                            Make your work easier with an integrated properly
                            together.
                          </p>
                          <div className="row g-4 margin-bottom-8">
                            <div className="col-lg-6">
                              <div className="d-flex gap-2 align-items-center clr-paragraph">
                                <div className="flex-shrink-0">
                                  <i className="far fa-check-circle"></i>
                                </div>
                                <p className="mb-0 flex-grow-1">
                                  Get real time answers
                                </p>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="d-flex gap-2 align-items-center clr-paragraph">
                                <div className="flex-shrink-0">
                                  <i className="far fa-check-circle"></i>
                                </div>
                                <p className="mb-0 flex-grow-1">
                                  Collaborate seamlessly
                                </p>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="d-flex gap-2 align-items-center clr-paragraph">
                                <div className="flex-shrink-0">
                                  <i className="far fa-check-circle"></i>
                                </div>
                                <p className="mb-0 flex-grow-1">
                                  Report on what matter
                                </p>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="d-flex gap-2 align-items-center clr-paragraph">
                                <div className="flex-shrink-0">
                                  <i className="far fa-check-circle"></i>
                                </div>
                                <p className="mb-0 flex-grow-1">
                                  Update Plans on the fly
                                </p>
                              </div>
                            </div>
                          </div>
                          <a
                            href="#"
                            className="link d-inline-flex text-center font-weight-semibold clr-white :clr-white rounded-pill padding-y-5 padding-x-10 bgc-primary lh-1"
                          >
                            Purchase Now
                          </a>
                        </div>
                        <div className="package-card__label package-card__label-primary">
                          <span className="d-block text-center font-weight-bold clr-white">
                            New
                          </span>
                          <span className="d-block text-center clr-white">
                            Offer
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tab-pane fade" id="yearly-package">
                  <div className="row g-4">
                    <div className="col-md-6">
                      <div className="package-card bgc-white rounded-4 padding-4 padding-xsm-6 padding-xl-8 d-flex flex-column flex-xl-row align-items-start gap-6">
                        <div className="padding-x-6 padding-y-8 bgc-secondary text-center rounded-pill flex-shrink-0">
                          <div className="d-flex align-items-start justify-content-center">
                            <h6 className="heading-6 mb-0 clr-white font-weight-bold">
                              $
                            </h6>
                            <h4 className="heading-4 mb-0 clr-white font-weight-bold">
                              54
                            </h4>
                          </div>
                          <p className="mb-0 clr-white font-weight-semibold">
                            /month
                          </p>
                        </div>
                        <div className="flex-grow-1">
                          <h5 className="heading-5 font-weight-bold clr-text margin-bottom-6">
                            Starter Plan
                          </h5>
                          <p className="clr-paragraph font-weight-bold margin-bottom-8">
                            Make your work easier with an integrated properly
                            together.
                          </p>
                          <div className="row g-4 margin-bottom-8">
                            <div className="col-lg-6">
                              <div className="d-flex gap-2 align-items-center clr-paragraph">
                                <div className="flex-shrink-0">
                                  <i className="far fa-check-circle"></i>
                                </div>
                                <p className="mb-0 flex-grow-1">
                                  Get real time answers
                                </p>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="d-flex gap-2 align-items-center clr-paragraph">
                                <div className="flex-shrink-0">
                                  <i className="far fa-check-circle"></i>
                                </div>
                                <p className="mb-0 flex-grow-1">
                                  Collaborate seamlessly
                                </p>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="d-flex gap-2 align-items-center clr-paragraph">
                                <div className="flex-shrink-0">
                                  <i className="far fa-check-circle"></i>
                                </div>
                                <p className="mb-0 flex-grow-1">
                                  Report on what matter
                                </p>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="d-flex gap-2 align-items-center clr-paragraph">
                                <div className="flex-shrink-0">
                                  <i className="far fa-check-circle"></i>
                                </div>
                                <p className="mb-0 flex-grow-1">
                                  Update Plans on the fly
                                </p>
                              </div>
                            </div>
                          </div>
                          <a
                            href="#"
                            className="link d-inline-flex text-center font-weight-semibold clr-text :clr-text border rounded-pill padding-y-5 padding-x-10 bgc-white lh-1"
                          >
                            Purchase Now
                          </a>
                        </div>
                        <div className="package-card__label">
                          <span className="d-block text-center font-weight-bold clr-white">
                            New
                          </span>
                          <span className="d-block text-center clr-white">
                            Offer
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="package-card bgc-white rounded-4 padding-4 padding-xsm-6 padding-xl-8 d-flex flex-column flex-xl-row align-items-start gap-6">
                        <div className="padding-x-6 padding-y-8 bgc-primary text-center rounded-pill flex-shrink-0">
                          <div className="d-flex align-items-start justify-content-center">
                            <h6 className="heading-6 mb-0 clr-white font-weight-bold">
                              $
                            </h6>
                            <h4 className="heading-4 mb-0 clr-white font-weight-bold">
                              54
                            </h4>
                          </div>
                          <p className="mb-0 clr-white font-weight-semibold">
                            /month
                          </p>
                        </div>
                        <div className="flex-grow-1">
                          <h5 className="heading-5 font-weight-bold clr-text margin-bottom-6">
                            Starter Plan
                          </h5>
                          <p className="clr-paragraph font-weight-bold margin-bottom-8">
                            Make your work easier with an integrated properly
                            together.
                          </p>
                          <div className="row g-4 margin-bottom-8">
                            <div className="col-lg-6">
                              <div className="d-flex gap-2 align-items-center clr-paragraph">
                                <div className="flex-shrink-0">
                                  <i className="far fa-check-circle"></i>
                                </div>
                                <p className="mb-0 flex-grow-1">
                                  Get real time answers
                                </p>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="d-flex gap-2 align-items-center clr-paragraph">
                                <div className="flex-shrink-0">
                                  <i className="far fa-check-circle"></i>
                                </div>
                                <p className="mb-0 flex-grow-1">
                                  Collaborate seamlessly
                                </p>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="d-flex gap-2 align-items-center clr-paragraph">
                                <div className="flex-shrink-0">
                                  <i className="far fa-check-circle"></i>
                                </div>
                                <p className="mb-0 flex-grow-1">
                                  Report on what matter
                                </p>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="d-flex gap-2 align-items-center clr-paragraph">
                                <div className="flex-shrink-0">
                                  <i className="far fa-check-circle"></i>
                                </div>
                                <p className="mb-0 flex-grow-1">
                                  Update Plans on the fly
                                </p>
                              </div>
                            </div>
                          </div>
                          <a
                            href="#"
                            className="link d-inline-flex text-center font-weight-semibold clr-white :clr-white rounded-pill padding-y-5 padding-x-10 bgc-primary lh-1"
                          >
                            Purchase Now
                          </a>
                        </div>
                        <div className="package-card__label package-card__label-primary">
                          <span className="d-block text-center font-weight-bold clr-white">
                            New
                          </span>
                          <span className="d-block text-center clr-white">
                            Offer
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreativeAgencyOneAddPlanner;
